import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/paths";

/**
 * Simple 404 Not Found page
 * Doesn't trigger state updates during render
 */
export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        padding: 4,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: "6rem",
          fontWeight: 700,
          color: "primary.main",
          marginBottom: 2,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        sx={{
          marginBottom: 1,
          fontWeight: 600,
        }}
      >
        Oooops! We couldn't find this page
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          marginBottom: 4,
        }}
      >
        Sorry for the inconvenience
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(Paths.Courier)}
        size="large"
      >
        Go to Couriers
      </Button>
    </Box>
  );
};
